export default __webpack_public_path__ + "static/media/LOGO_Red.38b8c898.png";